module.exports = __webpack_public_path__ + "img/04.6f4f0558.jpg";